import { Drawer, DrawerListItem } from '@components/drawer';
import { DrawerList } from '@pages/QuoteDetails/constants/DrawerList.enum';

export interface SideBarDrawerProps {
  toggleDrawer: (arg: DrawerList | null) => void;
  defaultItem?: string;
  items: DrawerListItem[];
  classNameToFindLastScrolled?: string;
}

export const SideBarDrawer = ({ items, defaultItem, toggleDrawer }: SideBarDrawerProps) => {
  return <Drawer items={items || undefined} toggleDrawer={toggleDrawer} defaultItem={defaultItem ?? undefined} />;
};
